/**
 * @generated SignedSource<<217e80098ca3617fc69468268d35cc45>>
 * @relayHash 2b16c4530e6a4991c643936f8b7f7a75
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 61418abde1b6f9e8308be8231e429dad5a1ab50e615aed86e4cf34c33e6a7d68

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type srcVirtualAgentLandingQuery$variables = {
  checkForAiEnabledFF: boolean;
  cloudId: string;
  projectKey: string;
};
export type srcVirtualAgentLandingQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly key: string;
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"ui_servicedeskSettingsVirtualAgentLanding_VirtualAgentLanding_projectRef" | "virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_projectRef">;
    } | null | undefined;
  } | null | undefined;
  readonly virtualAgent: {
    readonly virtualAgentEntitlements: {
      readonly " $fragmentSpreads": FragmentRefs<"ui_servicedeskSettingsVirtualAgentLanding_VirtualAgentLanding_featuresRef">;
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_featuresRef">;
};
export type srcVirtualAgentLandingQuery = {
  response: srcVirtualAgentLandingQuery$data;
  variables: srcVirtualAgentLandingQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "checkForAiEnabledFF"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v3 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v4 = [
  (v3/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "key"
},
v6 = {
  "kind": "ScalarField",
  "name": "name"
},
v7 = [
  (v3/*: any*/)
],
v8 = {
  "kind": "Variable",
  "name": "checkForAiEnabledFF",
  "variableName": "checkForAiEnabledFF"
},
v9 = {
  "kind": "ScalarField",
  "name": "id"
},
v10 = [
  (v9/*: any*/)
],
v11 = {
  "concreteType": "VirtualAgentQueryApi",
  "kind": "LinkedField",
  "name": "virtualAgent",
  "plural": false,
  "selections": [
    {
      "args": (v7/*: any*/),
      "concreteType": "VirtualAgentFeatures",
      "kind": "LinkedField",
      "name": "virtualAgentEntitlements",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isVirtualAgentAvailable"
        },
        {
          "condition": "checkForAiEnabledFF",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isAiEnabledInAdminHub"
            }
          ]
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "srcVirtualAgentLandingQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_projectRef"
              },
              {
                "kind": "FragmentSpread",
                "name": "ui_servicedeskSettingsVirtualAgentLanding_VirtualAgentLanding_projectRef"
              },
              (v5/*: any*/),
              (v6/*: any*/)
            ]
          }
        ]
      },
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "VirtualAgentQueryApi",
          "kind": "LinkedField",
          "name": "virtualAgent",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v7/*: any*/),
                "concreteType": "VirtualAgentFeatures",
                "kind": "LinkedField",
                "name": "virtualAgentEntitlements",
                "plural": false,
                "selections": [
                  {
                    "args": [
                      (v8/*: any*/)
                    ],
                    "kind": "FragmentSpread",
                    "name": "ui_servicedeskSettingsVirtualAgentLanding_VirtualAgentLanding_featuresRef"
                  }
                ]
              },
              "action": "THROW",
              "path": "virtualAgent.virtualAgentEntitlements"
            }
          ]
        },
        "action": "THROW",
        "path": "virtualAgent"
      },
      {
        "args": [
          (v8/*: any*/),
          (v3/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_featuresRef"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "srcVirtualAgentLandingQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "name": "virtualAgentConfiguration",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v10/*: any*/),
                    "type": "Node",
                    "abstractKey": "__isNode"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v10/*: any*/),
                    "type": "VirtualAgentQueryError"
                  }
                ]
              },
              (v9/*: any*/),
              (v6/*: any*/)
            ]
          }
        ]
      },
      (v11/*: any*/),
      (v11/*: any*/)
    ]
  },
  "params": {
    "id": "61418abde1b6f9e8308be8231e429dad5a1ab50e615aed86e4cf34c33e6a7d68",
    "metadata": {},
    "name": "srcVirtualAgentLandingQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a87551a7fc8df388e4e12bc6747ce998";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
